// رمز QR للتحقق من أصالة التقرير المختوم — يفتح صفحة عامة تعرض البصمة والحالة.
import { esc } from "./reportFormat";

const API = process.env.REACT_APP_BACKEND_URL || "";

export const verifyUrl = (hash) => `${API}/verify/${hash}`;

export const sealQr = (data, L) => {
  const hash = data?.seal_hash;
  if (!data?.sealed || !hash) return "";
  return `<div class="qr">
    <img class="qr-img" src="${esc(`${API}/api/verify/seal/${hash}/qr.png?scale=4`)}" alt="QR" />
    <div class="qr-text">
      <div class="qr-title">${esc(L.verifyTitle)}</div>
      <div class="qr-hash" dir="ltr">${esc(hash)}</div>
      <div class="qr-url" dir="ltr">${esc(verifyUrl(hash))}</div>
    </div>
  </div>`;
};
